// src/Dashboard/pages/user/FicheAdherent/utils/ficheAdherentDashboardUtils.js

export const defaultAvatar = (genre) =>
  genre === "Féminin" ? "/img/judokate_avatar.png" : "/img/judoka_avatar.png";

export const toAbsoluteUploadUrl = (url) => {
  if (!url) return "";

  const value = String(url).trim();

  if (
    /^https?:\/\//i.test(value) ||
    value.startsWith("data:") ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  if (!value.startsWith("/uploads")) {
    return value;
  }

  const base = process.env.REACT_APP_API_URL?.replace(/\/$/, "") || "";
  return `${base}${value}`;
};

export const getAdherentPhotoUrl = (adherent) => {
  const photo = toAbsoluteUploadUrl(adherent?.photo_url);
  return photo || defaultAvatar(adherent?.genre);
};

export const formatAdherentName = (adherent) => {
  if (!adherent) return "Adhérent";

  const nom = String(adherent.nom || "").toUpperCase();
  const prenom = adherent.prenom || "";

  return `${nom} ${prenom}`.trim() || "Adhérent";
};

export const formatDateFR = (date) => {
  if (!date) return "—";

  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) return "—";

  return parsed.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
};

export const getStatusPillClass = (statut) => {
  switch (statut) {
    case "Licencié":
      return "bg-emerald-100 text-emerald-800 ring-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-200 dark:ring-emerald-800/60";
    case "Licencié Hors Club":
      return "bg-lime-100 text-lime-800 ring-lime-200 dark:bg-lime-900/30 dark:text-lime-200 dark:ring-lime-800/60";
    case "Inscrit":
      return "bg-amber-100 text-amber-800 ring-amber-200 dark:bg-amber-900/30 dark:text-amber-200 dark:ring-amber-800/60";
    case "Cours d'essai":
      return "bg-rose-100 text-rose-800 ring-rose-200 dark:bg-rose-900/30 dark:text-rose-200 dark:ring-rose-800/60";
    case "Licencié - Arrêt":
    case "Ancien Licencié et Arrêt":
      return "bg-slate-200 text-slate-700 ring-slate-300 dark:bg-slate-800 dark:text-slate-200 dark:ring-slate-700";
    case "Ancien Licencié":
      return "bg-slate-900 text-white ring-slate-900 dark:bg-white dark:text-slate-900 dark:ring-white";
    case "Non Licencié - Arrêt":
      return "bg-slate-500 text-white ring-slate-500";
    default:
      return "bg-slate-100 text-slate-700 ring-slate-200 dark:bg-slate-800 dark:text-slate-200 dark:ring-slate-700";
  }
};

export const normalizeSearch = (value) =>
  String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "");